import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

export const dialogSmsOpenSlice = createSlice({
 name: 'dialogSmsOpen',
 initialState,
 reducers: {
  dialogSmsOpen: (state, action: PayloadAction<boolean>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { dialogSmsOpen } = dialogSmsOpenSlice.actions;

export default dialogSmsOpenSlice.reducer;
